<script>
import { Line } from 'vue-chartjs'

export default {
  extends: Line,
  props: {
    data: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
    plugins: {
      type: Array,
      default: null,
    },
    styles: {
      type: Object,
      default: null,
    },
  },
  watch: {
    data: {
      deep: true,
      handler(val) {
        if (val.labels) {
          const dataset = {
            labels: val.labels || [],
            datasets: val.datasets || [],
          }
          this.renderChart(dataset, this.options, this.plugins, this.styles)
        }
      },
    },
  },
  mounted() {
    this.renderChart(this.data, this.options, this.plugins, this.styles)
  },
}
</script>
